class CollectionLoadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-load-more-button]');
    this.grid = document.getElementById('product-grid');
    this.sectionId = this.dataset.sectionId;
    this.pageSize = parseInt(this.dataset.pageSize, 10);
    this.totalItems = parseInt(this.dataset.totalItems, 10);
    this.currentPage = parseInt(this.dataset.currentPage, 10);
    this.totalPages = parseInt(this.dataset.totalPages, 10);

    if (this.button) {
      this.button.addEventListener('click', this.handleClick.bind(this));
    }
  }

  handleClick(event) {
    event.preventDefault();
    if (this.loading) return;
    this.load();
  }

  async load() {
    const nextUrl = this.button.getAttribute('href');
    if (!nextUrl) return;

    this.setLoading(true);

    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);

      const response = await fetch(url.toString());
      if (!response.ok) throw new Error('Network response was not ok');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newItems = doc.querySelectorAll('#product-grid > li.grid__item');
      const newLoadMore = doc.querySelector('collection-load-more');

      if (newItems.length > 0) {
        const fragment = document.createDocumentFragment();
        const firstNewItem = newItems[0];

        this.releaseRevealedItems();

        newItems.forEach((item, index) => {
          item.style.setProperty('--animation-order', index + 1);
          fragment.appendChild(item.cloneNode(true));
        });

        this.grid.appendChild(fragment);
        this.updateCount();
        this.initializeNewItems();

        if (firstNewItem) {
          const addedFirstItem = this.grid.querySelector(`li:nth-child(${this.grid.children.length - newItems.length + 1})`);
          if (addedFirstItem) {
            const focusableElement = addedFirstItem.querySelector('a, button') || addedFirstItem;
            focusableElement.focus({ preventScroll: true });
          }
        }
      }

      this.currentPage++;
      this.updateUrl();
      this.dataset.currentPage = this.currentPage;

      if (newLoadMore) {
        const newButton = newLoadMore.querySelector('[data-load-more-button]');

        if (newButton) {
          this.button.setAttribute('href', newButton.getAttribute('href'));
        } else {
          this.button.remove();
          this.button = null;
        }
      } else {
        this.button.remove();
        this.button = null;
      }

      this.setLoading(false);
    } catch (error) {
      console.error('Load more failed:', error);
      this.setLoading(false);
      window.location.href = this.button.getAttribute('href');
    }
  }

  setLoading(loading) {
    this.loading = loading;
    if (!this.button) return;

    const buttonText = this.button.querySelector('.collection-load-more__button-text');
    const spinner = this.button.querySelector('.collection-load-more__spinner');

    if (loading) {
      this.button.setAttribute('aria-busy', 'true');
      this.button.classList.add('loading');
      if (buttonText) buttonText.classList.add('hidden');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      this.button.removeAttribute('aria-busy');
      this.button.classList.remove('loading');
      if (buttonText) buttonText.classList.remove('hidden');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  releaseRevealedItems() {
    this.grid.querySelectorAll('.scroll-trigger:not(.scroll-trigger--offscreen)').forEach((item) => {
      item.classList.remove('scroll-trigger', 'animate--slide-in');
    });
  }

  shownCount() {
    return this.grid.querySelectorAll(':scope > li.grid__item').length;
  }

  updateCount() {
    const countLabel = this.querySelector('.collection-load-more__count');
    const template = this.dataset.countLabel;
    if (!countLabel || !template) return;

    countLabel.textContent = template.replace('[shown]', this.shownCount()).replace('[total]', this.totalItems);
  }

  initializeNewItems() {
    const newItems = Array.from(this.grid.querySelectorAll('.scroll-trigger'));

    if (typeof initializeScrollAnimationTrigger === 'function') {
      initializeScrollAnimationTrigger(this.grid);
    } else {
      newItems.forEach((item) => {
        item.classList.remove('scroll-trigger', 'scroll-trigger--offscreen', 'animate--slide-in');
      });
    }
  }

  updateUrl() {
    const url = new URL(window.location.href);
    url.searchParams.set('page', this.currentPage);
    history.replaceState({ searchParams: url.search.slice(1) }, '', url.toString());
  }
}

customElements.define('collection-load-more', CollectionLoadMore);
